export const ADDFRAMEWORK = () => ({ type: 'ADD_FRAMEWORK' })
export const LOG_OUT =  () => ({ type: 'LOG_OUT' })
export const LOG_IN =  (token,userInfo, status) => ({ type: 'LOG_IN', payload: {token : token, userInfo : userInfo, status : status } })
export const USER_INFO =  (userinfo) => ({type: 'USER_INFO', payload: {userinfo: userinfo}})
export const USER_VERIFIED =  (user_verified) => ({type: 'USER_VERIFIED', payload: {user_verified: user_verified}})
